const IconCurrentLocation = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M9 10.125C9.62132 10.125 10.125 9.62132 10.125 9C10.125 8.37868 9.62132 7.875 9 7.875C8.37868 7.875 7.875 8.37868 7.875 9C7.875 9.62132 8.37868 10.125 9 10.125Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9.5625 2.64948V5.0625C9.5625 5.37316 9.31066 5.625 9 5.625C8.68934 5.625 8.4375 5.37316 8.4375 5.0625V2.64948C5.36548 2.91804 2.91804 5.36548 2.64948 8.4375H5.0625C5.37316 8.4375 5.625 8.68934 5.625 9C5.625 9.31066 5.37316 9.5625 5.0625 9.5625H2.64948C2.91804 12.6345 5.36548 15.082 8.4375 15.3505V12.9375C8.4375 12.6268 8.68934 12.375 9 12.375C9.31066 12.375 9.5625 12.6268 9.5625 12.9375V15.3505C12.6345 15.082 15.082 12.6345 15.3505 9.5625H12.9375C12.6268 9.5625 12.375 9.31066 12.375 9C12.375 8.68934 12.6268 8.4375 12.9375 8.4375H15.3505C15.082 5.36548 12.6345 2.91804 9.5625 2.64948Z'
        fill={fill}
      />
    </svg>
  )
}

export default IconCurrentLocation
